import React from "react";
import "./StepTwo.style.scss";
import arrayImgs from "../../imgs/scammer";
import SliderScammerComponent from "../slider/Slider_scammer";

export default function StepTwo() {
    const arrayText = [
        "Ніколи та нікому не передавайте секретний код та пароль від особистого кабінету. Вони можуть надходити в смс, месенджерах або на електронну пошту. Якщо хтось отримає доступ до облікового запису, то зможе отримати доступ і до електронної пошти й до ваших рахунків.\nJustin може попросити вас назвати код із смс виключно при отриманні посилки без документів у відділенні. Цей код генерується автоматично під час вашого перебування у відділенні.",
        "Уважно перевіряйте сайт або мобільний додаток, на яких вводите пароль до особистого кабінету. Justin має єдиний офіційний сайт (https://justin.ua/) та мобільний додаток (IOS Android). Шахраї можуть їх підробляти та видавати за офіційні. Захищений сайт містить у рядку адреси https:// та значок «Замок». Перевірити сайт можна за допомогою спеціального сервісу кіберполіції або сервісу Асоціації ЕМА.",
    ];
    return <div className="step_two_scammer">
        <img id="boy" src={arrayImgs.Boy} alt="scammer"/>
        <div className="wrapper_text">
            <p>2 поради, як безпечно користуватися мобільним додатком та сайтом</p>
            <SliderScammerComponent arrayText={arrayText}/>
        </div>
    </div>
}